import { createSelector } from 'reselect';

export const fetchingCurrencyConversionRatesSelector = state =>
  state.administration.currencyConversionRates.fetchingCurrencyConversionRates;

export const isSavingInProgressSelector = state =>
  state.administration.currencyConversionRates.isSavingInProgress;

export const isRemovingInProgressSelector = state =>
  state.administration.currencyConversionRates.isRemovingInProgress;

export const currencyConversionRatesSelector = state =>
  state.administration.currencyConversionRates.currencyConversionRates;

export const extendedUploadedCurrencyConversionRatesSelector = state =>
  state.administration.currencyConversionRates.extendedUploadedCurrencyConversionRates;

export const uploadingCurrencyConversionRatesSelector = state =>
  state.administration.currencyConversionRates.uploadingCurrencyConversionRates;

export const importingCurrencyConversionRatesSelector = state =>
  state.administration.currencyConversionRates.importingCurrencyConversionRates;

export const importingCurrencyConversionRatesProgress = state =>
  state.administration.currencyConversionRates.importingCurrencyConversionRatesProgress;

export const areImportsPendingSelector = createSelector(
  extendedUploadedCurrencyConversionRatesSelector,
  uploadedRates => !(uploadedRates.some(({ validationData }) => !!validationData)
    || uploadedRates.length === 0));

export const missingRatesSelector = state =>
  state.administration.currencyConversionRates.missingRates;

export const currencyOptionsSelector = state =>
  state.administration.currencyConversionRates.currencyOptions;

export const importStatsSelector = state =>
  state.administration.currencyConversionRates.importStats;
